import {googleAds} from '../../../externalTrackers/index.js'
import {DEFAULT_CONVERSION_ID, EVENTS_MAPPING} from './config.js'

const trackerFactory = ({id}) => googleAds({id})

export default ({event, isPage}) => {
  const allowedEvents = Object.keys(EVENTS_MAPPING)

  const needToTrack = allowedEvents.includes(event)

  if (needToTrack) {
    const {label, conversionId} = EVENTS_MAPPING[event]

    const track = trackerFactory({id: conversionId})
    track({label})
  }

  const track = trackerFactory({id: DEFAULT_CONVERSION_ID})
  isPage && track({event: 'page_view', allowAdPersonalization: true})
}
